import { ClassAttributes, HTMLAttributes, useContext } from 'react';
import { Row, Col } from 'reactstrap';
import {
  Table,
  Column,
  AutoSizer,
  InfiniteLoader,
  RowMouseEventHandlerParams,
} from 'react-virtualized';

import PageContainer from 'common/PageContainer';
// Make sure the path and file exist, or update the path as needed:
import { FILTERS } from '../../constant'; // Try changing to 'constants' if that's the correct file name

// If the file does not exist, create '../constants.ts' with the following content:
// export const FILTERS = [/* your filter criteria here */];
import { BookingsContext } from '../../context';
import PageLoader from 'common/PageLoader';
import { PersonCircle } from 'react-bootstrap-icons';
import { JSX } from 'react/jsx-runtime';
import { useNavigate } from 'react-router';
import Header from 'components/Header';
import { Search } from 'common/Search';
import { Filter } from 'common/Filter';
import NoData from 'common/NoData';
import moment from 'moment';
import { useSelector } from 'react-redux';
import { DatePicker } from 'common/DatePicker';
import { DATES } from 'common/DatePicker/dateConstant';
import ExportExcel from 'components/ExportExcel/ExportExcel';
import { formatBookingData } from 'utils/excelFormat/formatBookingData';
import { bookingExcelConfig } from 'utils/excel/bookingExcelConfig';

const GridFilterBar = ({
  filterCriteria,
  onSearch,
  onClearSearch,
  allData
}: {
  filterCriteria: any;
  onSearch: (searchTerm: string) => void;
  onClearSearch: () => void;
  allData: any[];
}) => {
  const { searchKeyword } = useSelector((state: any) => state.bookings);
  console.log('@@ searchKeyword from redux at GridFilterBar:', searchKeyword);
  return (
    <Row className="mb-2 mt-2">
      <Col sm={12} md={3}>
        <Search
          searchKeyword={searchKeyword}
          onSearch={onSearch}
          onClearSearch={onClearSearch}
        />
      </Col>
      <Col sm={12} md={6} className="d-flex align-items-center">
        <Filter filterCriteria={filterCriteria} />
      </Col>
      <Col md={3}>
        <DatePicker filterCriteria={DATES} />
        {
          allData && allData.length > 0 && (
            <ExportExcel allData={(formatBookingData(allData))}  config={bookingExcelConfig}  />
          )
        }
      </Col>
    </Row>
  );
};

const rowRenderer = (props: {
  className: any;
  columns: any;
  index?: number;
  isScrolling?: boolean;
  key?: string;
  onRowClick?: (id: any) => void;
  onRowDoubleClick?: ((params: RowMouseEventHandlerParams) => void) | undefined;
  onRowMouseOver?: ((params: RowMouseEventHandlerParams) => void) | undefined;
  onRowMouseOut?: ((params: RowMouseEventHandlerParams) => void) | undefined;
  onRowRightClick?: ((params: RowMouseEventHandlerParams) => void) | undefined;
  rowData: any;
  style: any;
}) => {
  const { columns, className, rowData, style, onRowClick } = props;
  if (!rowData) {
    console.warn('Row data is missing:', props);
    return null;
  }
  console.log('props.rowdata.....', props.rowData);
  const { id, startTime } = rowData;

  console.log(
    'user billing address..',
    rowData.billingAddress.address,
    rowData.billingAddress.city
  );

  const name = rowData?.user?.firstName
    ? `${rowData.user.firstName
        .charAt(0)
        .toUpperCase()}${rowData.user.firstName.substring(1)} ${
        rowData.user?.lastName
          ? `${rowData.user.lastName
              .charAt(0)
              .toUpperCase()}${rowData.user.lastName.substring(1)}`
          : ''
      }`
    : '---';

  const phone = rowData.user ? `${rowData.user.phone || ''}` : '---';

  const address = rowData.billingAddress
    ? `${rowData.billingAddress.address || ''}, ${
        rowData.billingAddress.city || ''
      }, ${rowData.billingAddress.zip || ''}`
    : '-';

  const chefName = rowData.chef
    ? `${rowData.chef.firstName || ''} ${rowData.chef.lastName || ''}`
    : '';
  console.log(
    ',,,,,,,,,,,,,,,,,chef...',
    rowData.chef.firstName,
    rowData.chef.lastName
  );

  return (
    <div
      className={className}
      style={style}
      onClick={() => onRowClick?.(id)}
      key={`customer-row-${id}`}
    >
      {columns.map(
        (col: {
          props: JSX.IntrinsicAttributes &
            ClassAttributes<HTMLDivElement> &
            HTMLAttributes<HTMLDivElement>;
        }) => {
          const keyName: any = col.props['aria-describedby'];

          let value = rowData[keyName];

          if (typeof value === 'object' && value !== null) {
            value = JSON.stringify(value);
          }
          if (keyName === 'Name') {
            return (
              <div
                {...col.props}
                title={name}
                key={`${col.props['aria-describedby']}-cell-${id}`}
              >
                <PersonCircle className="me-2" size={20} />

                <span>{name && name.trim()?.length ? name : '--'}</span>
              </div>
            );
          }
          if (keyName === 'phone') {
            return (
              <div {...col.props} title={phone} key={`${keyName}-cell-${id}`}>
                {phone}
              </div>
            );
          }

          if (keyName === 'billingAddress') {
            return (
              <div {...col.props} title={address} key={`${keyName}-cell-${id}`}>
                {address}
              </div>
            );
          }

          if (keyName === 'meals') {
            // value = meals.join(", ");
            value = rowData?.meals?.length
              ? rowData.meals
                  .map(
                    (meal: any) =>
                      meal.charAt(0).toUpperCase() + meal.substring(1)
                  )
                  .join(', ')
              : 'N/A';
          }

          if (keyName === 'startTime') {
            value =
              moment(
                startTime.replace('.', ':').toUpperCase(),
                'h:mm A'
              ).format('hh:mm A') || 'N/A';
          }

          if (keyName === 'startDate') {
            value = moment(rowData.startDate).format('DD/MM/YYYY') || 'N/A';
          }

          if (keyName === 'chefName') {
            return (
              <div
                {...col.props}
                title={chefName}
                key={`${col.props['aria-describedby']}-cell-${id}`}
              >
                <span>
                  {chefName && chefName.trim()?.length ? (
                    <>
                      {' '}
                      <PersonCircle className="me-2" size={20} /> ${chefName}{' '}
                    </>
                  ) : (
                    'Unassigned'
                  )}
                </span>
              </div>
            );
          }

          return (
            <div
              {...col.props}
              title={value || '-'}
              key={`${col.props['aria-describedby']}-cell-${id}`}
            >
              {value || '-'}
            </div>
          );
        }
      )}
    </div>
  );
};

const BookingList = () => {
  const navigate = useNavigate();

  const bookingsContext = useContext(BookingsContext);

  if (!bookingsContext || !bookingsContext.bookingData) {
    return <div>Context not available</div>;
  }

  const {
    bookingData: { isLoading, status, error, data: bookings, totalBooking },
    loadMore,
    handleSearchChange,
    handleClearSearch,
  } = bookingsContext;
  console.log('response index ', bookings);

  const handleRowClick = (bookingId: any) =>
    navigate(`${bookingId}/details`, {
      state: { heading: 'Booking Details', iconClass: 'bi bi-chevron-left' },
    });

  if (isLoading) return <PageLoader />;
  if (error) {
    return <span>Something went wrong!</span>;
  }
  if (status === 200 && !bookings.length) return <span>No data found!</span>;
  if (status === 200) {
    return (
      <>
        <PageContainer>
          <Header totalCount={totalBooking} heading={'Bookings'} />

          <GridFilterBar
            filterCriteria={FILTERS}
            onSearch={handleSearchChange}
            onClearSearch={handleClearSearch}
            allData={bookings}
          />
          <Row className="mt-4">
            <Col>
              {bookings.length > 0 ? (
                <InfiniteLoader
                  isRowLoaded={({ index }) => !!bookings[index]}
                  loadMoreRows={loadMore}
                  rowCount={totalBooking}
                >
                  {({ onRowsRendered, registerChild }) => (
                    <AutoSizer>
                      {({ width }) => (
                        <Table
                          ref={registerChild}
                          onRowsRendered={onRowsRendered}
                          rowClassName="table-row"
                          headerHeight={32}
                          width={width}
                          height={750}
                          rowHeight={50}
                          rowCount={bookings.length}
                          rowGetter={({ index }) => bookings[index]}
                          rowRenderer={(props) =>
                            rowRenderer({
                              ...props,
                              onRowClick: handleRowClick,
                            })
                          }
                        >
                          <Column
                            label="Name"
                            dataKey="name"
                            width={width * 0.2}
                            id="Name"
                          />

                          <Column
                            id="phone"
                            label="Phone"
                            dataKey="phone"
                            width={width * 0.2}
                          />
                          <Column
                            id="meals"
                            label="Meals"
                            dataKey="meals"
                            width={width * 0.2}
                          />
                          <Column
                            id="headCount"
                            label="Person"
                            dataKey="headCount"
                            width={width * 0.2}
                          />
                          <Column
                            id="billingAddress"
                            label="Address"
                            dataKey="billingAddress."
                            width={width * 0.3}
                          />

                          <Column
                            id="startDate"
                            label="Date"
                            dataKey="startDate"
                            width={width * 0.2}
                          />
                          <Column
                            id="startTime"
                            label="Time"
                            dataKey="startTime"
                            width={width * 0.2}
                          />
                          <Column
                            id="chefName"
                            label="Chef"
                            dataKey="chefName"
                            width={width * 0.2}
                          />
                        </Table>
                      )}
                    </AutoSizer>
                  )}
                </InfiniteLoader>
              ) : (
                <NoData customMessage={'No result found. '} />
              )}
            </Col>
          </Row>
        </PageContainer>
      </>
    );
  }

  return null;
};

export default BookingList;
